import * as React from "react";
import { Typography } from "antd";

import styles from "./Section.module.less";

const { Title } = Typography;

export interface SectionProps {
  /**
   * section title
   */
  title?: string;
}

/**
 * Game plan section with title and content
 * @param title
 * @param children
 * @constructor
 */
const Section: React.FC<SectionProps> = ({ title, children }) => (
  <section>
    {title && (
      <Title level={5} className={styles.Title}>
        {title}
      </Title>
    )}
    {children}
  </section>
);

export default Section;
